// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"df8abbac","455":"cba48264","977":"4913b6aa"}[chunkId] + ".chunk.js";
};